import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import Table from './Table/index'
import Download from './Download'
import Upload from './Upload'
import AddVehicleModal from '../Modal/AddVehicleModal'
import config from '../../config'
import locationApi from '../../utils/locationApi'

const url = config.api.baseUrl + '/vehicles'

const Vehichle = (props) => {
  const [vehichleData, setVehichleData] = useState([])
  const [showAddVehicleModal, setShowAddVehicleModal] = useState(false)

  const toggleAddVehicleModal = () => setShowAddVehicleModal(!showAddVehicleModal)

  useEffect(() => {
    (async () => {
      const res = await locationApi('get', url)
      setVehichleData(res.data)
    })()
  }, [])

  const columns = [
    {
      Header: 'PMID',
      accessor: 'pmId'
    },
    {
      Header: 'Registration No.',
      accessor: 'reg'
    },
    {
      Header: 'Branches',
      accessor: 'branches',
      Cell: props => <span>{props.value?.join(', ')}</span>
    },
    {
      Header: 'CSEID',
      accessor: 'cseId'
    },
    {
      Header: 'Pipe Line ID',
      accessor: 'pipelineId'
    },
    {
      Header: 'Acetrack ID',
      accessor: 'acetrackId'
    }
  ]

  return (
    <>
      <Table
        columns={columns}
        data={vehichleData}
      />
      <Download data={vehichleData} />
      <Upload />
      <Button variant='primary' onClick={toggleAddVehicleModal}>Add Vehichle</Button>
      <AddVehicleModal show={showAddVehicleModal} onClose={toggleAddVehicleModal} />
    </>
  )
}

export default Vehichle
